import Icon from 'components/Icon/Icon';
import {useGlobalState} from 'hooks/useGlobalState';

export default function PubSwitcherLogo() {
  const {managedPub} = useGlobalState((state) => state.managedPub);
  return managedPub?.attributes.pub_logo ? (
    <img
      src={managedPub?.attributes.pub_logo}
      style={{
        width: 35,
        height: 35,
        borderRadius: 35,
      }}
      alt="Pub Logo"
    />
  ) : (
    <Icon icon="switch-account-3" />
  );
}
